module.exports = __webpack_public_path__ + "media/img/bg-camera-0892b838b05a2ed9e84902a09847b73f.png";